import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_EMPLOYEES_QUERY } from "../../graphql/Employees/Employees.graphql";

function DriverSelect({
  where,
  value,
  label,
  size,
  name,
  icon,
  onChange,
  readOnly,
  required,
  addon,
  useSupervisorFilter,
  user
}) {
  const filters = { ...where, DriverFlag: true, Active: true };
  const { data, loading, error } = useQuery(ALL_EMPLOYEES_QUERY, {
    variables: {
      where:
        useSupervisorFilter && user?.EmployeeRecIdRef
          ? { ...filters, SupervisorRecIdRef: user.EmployeeRecIdRef }
          : { ...filters },
      orderByMulti: ["LastName_ASC"]
    }
  });

  return (
    <Field kind={addon ? "addons" : ""}>
      <Label size={size}>{label}</Label>
      <Control iconLeft={!!icon} size={size}>
        <Select.Container
          fullwidth
          color={
            error ||
            (required && (value === "" || value === "0" || value === 0))
              ? "danger"
              : ""
          }
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select
            disabled={readOnly}
            name={name}
            value={value}
            onChange={onChange}
          >
            <Select.Option value="">{label}</Select.Option>
            {!loading &&
              data.Employees.map((Employee, i) => (
                <Select.Option
                  key={`employee-select-${i}`}
                  value={Employee.RecId}
                >
                  {Employee.LastName}, {Employee.FirstName}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left" size={size}>
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
      {addon && <Control>{addon}</Control>}
    </Field>
  );
}

DriverSelect.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  where: PropTypes.object,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  addon: PropTypes.node,
  useSupervisorFilter: PropTypes.bool,
  user: PropTypes.object
};

DriverSelect.defaultProps = {};
export default DriverSelect;
